import React from 'react';
import ReactDOM from 'react-dom';
import { I18nextProvider } from 'react-i18next';
import { Provider } from 'react-redux';

import i18n from '../../i18n';
import FastBooking from './components/FastBooking';
import createStore from './createPersistedStore';
import taggingMiddleware from './middlewares/tagging';

export default function () {
  const root = document.getElementById('FastBookingRoot');

  if (root) {
    const site = root.getAttribute('data-site') || '';
    const siteInitial = site ? { site } : {};

    const keepCart = new URLSearchParams(window.location.search).get('keep') === 'true';

    const initialState = { booking: { departure: siteInitial, arrival: siteInitial } };

    const persistedStore = createStore('estimate', initialState, [taggingMiddleware]);

    if (!keepCart) persistedStore.persistor.purge();

    ReactDOM.render(
      <React.Suspense fallback={<div className="fallback" />}>
        <Provider store={persistedStore.store}>
          <I18nextProvider i18n={i18n}>
            <FastBooking persistor={persistedStore.persistor} />
          </I18nextProvider>
        </Provider>
      </React.Suspense>,
      root,
    );
  }
}
